import { ReactComponent as shop } from 'assets/icons/shop.svg';
import { ReactComponent as menu } from 'assets/icons/menu.svg';
import { ReactComponent as union } from 'assets/icons/union.svg';
import { ReactComponent as circleAdd } from 'assets/icons/circle-add.svg';
import { ReactComponent as add } from 'assets/icons/add.svg';
import { ReactComponent as search } from 'assets/icons/search.svg';
import { ReactComponent as notification } from 'assets/icons/notification.svg';
import { ReactComponent as rightArrow } from 'assets/icons/right-arrow.svg';
import { ReactComponent as leftArrow } from 'assets/icons/left-arrow.svg';
import { ReactComponent as addFilled } from 'assets/icons/add-filled.svg';
import { ReactComponent as addSquare } from 'assets/icons/add-square.svg';
import { ReactComponent as minusSquare } from 'assets/icons/minus-square.svg';
import { ReactComponent as minus } from 'assets/icons/minus.svg';
import { ReactComponent as checkbox } from 'assets/icons/checkbox.svg';
import { ReactComponent as checkboxSelected } from 'assets/icons/checkbox-selected.svg';
import { ReactComponent as bankcard } from 'assets/icons/bankcard.svg';
import { ReactComponent as cash } from 'assets/icons/cash.svg';
import { ReactComponent as wechat } from 'assets/icons/wechat.svg';
import { ReactComponent as alipay } from 'assets/icons/alipay.svg';
import { ReactComponent as close } from 'assets/icons/close.svg';
import { ReactComponent as info } from 'assets/icons/info.svg';
import { ReactComponent as trash } from 'assets/icons/trash.svg';
import { ReactComponent as closeGrayBg } from 'assets/icons/close-gray-bg.svg';
import { ReactComponent as paypal } from 'assets/icons/paypal.svg';
import { ReactComponent as addToCart } from 'assets/icons/add-to-cart.svg';

export const IconMap = {
  shop,
  menu,
  union,
  circleAdd,
  search,
  add,
  notification,
  rightArrow,
  leftArrow,
  minus,
  addFilled,
  checkbox,
  checkboxSelected,
  bankcard,
  cash,
  wechat,
  paypal,
  alipay,
  close,
  info,
  trash,
  addSquare,
  minusSquare,
  closeGrayBg,
  addToCart,
};
